import firebase from 'firebase/app'
import 'firebase/firestore'



const firebaseConfig = {
    apiKey: "AIzaSyDbz9YsFH9oSyvrdhT-RcCa-iz2SaZ0aBo",
    authDomain: "chilllists.firebaseapp.com",
    projectId: "chilllists",
    storageBucket: "chilllists.appspot.com",
    messagingSenderId: "117944214317",
    appId: "1:117944214317:web:81ff666c60862bb3a0a9a4",
    measurementId: "G-RSDWXCDZH3"
  };

  firebase.initializeApp(firebaseConfig)

  export default firebase.firestore();